export default __webpack_public_path__ + "static/media/myResume.c3d6bf95.jpg";